<template>
	<b-modal ref="modal" title="Change your password" :busy="loading>0">
		<b-form @submit.stop.prevent="changePassword()" id="changePasswordForm">
			<b-form-group label="Current password">
				<b-form-input type="password" v-model="currentPassword" placeholder="Current password" required></b-form-input>
			</b-form-group>
			<b-form-group label="New password">
				<b-form-input type="password" v-model="password" placeholder="New password" required></b-form-input>
			</b-form-group>
			<b-form-group label="New password (repeat)">
				<b-form-input type="password" v-model="password2" placeholder="New password (repeat)" required></b-form-input>
			</b-form-group>
		</b-form>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{ ok, cancel }">
			<div class="w-100">
				<div class="float-right">
					<b-spinner v-show="loading>0" small label="Spinning" class="mr-3"></b-spinner>
					<b-button variant="primary" type="submit" form="changePasswordForm" class="mr-2">
						Change
					</b-button>
					<b-button size="sm" @click="cancel()">
						Cancel
					</b-button>
				</div>
			</div>
		</template>
	</b-modal>
</template>

<script>
export default {
	data: () => ({
		currentPassword: '',
		password: '',
		password2: '',
		loading: 0,
		error: null,
	}),
	methods: {
		show() {
			this.$refs.modal.show();
		},
		async changePassword() {
			this.loading++;
			try {
				await this.$api.post('changePassword', {
					currentPassword: this.currentPassword,
					password: this.password,
				});
				this.$refs.modal.hide();
				this.$bvToast.toast('Successfully changed password.', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
				this.$emit('saved');
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
	},
}
</script>
